import { useQuery } from '@tanstack/react-query';
import { ApiService } from '@/_services/api.service';
import { queryKeys } from './queryKeys';
import type { IDataPoolEntry } from '@/types';

/**
 * Query hook for fetching data pool entries for a conversation.
 * Automatically fetches when a valid conversationId is provided.
 */
export const useDataPoolQuery = (conversationId: string | null) => {
	return useQuery({
		queryKey: queryKeys.dataPool.byConversation(conversationId ?? ''),
		queryFn: async (): Promise<IDataPoolEntry[]> => {
			if (!conversationId) return [];

			const response = await ApiService.GetDataPool(conversationId);

			if (response.error) {
				throw new Error(response.error.message);
			}

			return response.data ?? [];
		},
		enabled: !!conversationId,
		staleTime: 30 * 1000, // 30 seconds — data pool grows as messages stream
		gcTime: 10 * 60 * 1000
	});
};
